export enum YesNoType {
  YES = 'S',
  NO  = 'N'
}
